<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{Translate('Create Temperature Inspection')}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Inspection">close</i>
  </div>



  <div class="ttmodal__body">
    <div *ngIf="isInspector" style="width: 500px;">

      <div *ngIf="!hasEquipment">
          <mat-form-field class="setup-form-full-width">
              <mat-select (selectionChange)="customerChanged($event)" name="customer" placeholder="{{Translate('Select Customer')}}">
                <mat-option *ngFor="let customer of _dropDownLists.customerList" [value]="customer">
                  {{ customer.Title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
  
            <mat-form-field class="setup-form-full-width">
              <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite" placeholder="{{Translate('Select Job Site')}}">
                <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                  {{ jobsite.Title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <mat-form-field class="setup-form-full-width">
              <mat-select (selectionChange)="equipmentChanged($event)" name="equipment" placeholder="{{Translate('Select Equipment')}}">
                <mat-option *ngFor="let equipment of _dropDownListsFiltered.equipmentList" [value]="equipment">
                  {{ equipment.Serial+ ' : ' + equipment.Unit }}
                </mat-option>
              </mat-select>
            </mat-form-field>
      </div>
      <mat-form-field class="setup-form-full-width">
        <input matInput  [min]="EquipmentSetupDate"  [max]="todate"  readonly [matDatepicker]="myDatepicker" placeholder="{{'Select Inspection Date' | translate | async}}"  [(ngModel)]="dateReplaced" >
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="setup-form-full-width">
          <input type="number" min="0" matInput placeholder="{{'SMU' | translate | async}}"  [(ngModel)]="selectedSMU">
        </mat-form-field>
        
        <mat-form-field class="setup-form-full-width">
            <input type="number" min="0" matInput placeholder="{{'Ambient Temperature' | translate | async}}"  [(ngModel)]="ambientTemp">
            <span matSuffix>°C</span>
          </mat-form-field>

          <mat-radio-group aria-label="Select Side" [(ngModel)]="selectedSide">
              <mat-radio-button [value]="1">Left Side</mat-radio-button>
              <mat-radio-button [value]="2" style="margin-left: 40%;">Right Side</mat-radio-button>
            </mat-radio-group>

          <div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 2%;" *ngIf="selectedSide==1" >
           
              <mat-form-field > 
                  <input type="number" min="0" matInput placeholder="{{'Number' | translate | async}}"  [(ngModel)]="pinNOL" [readonly]="true">
                </mat-form-field>
          <mat-form-field>
              <input type="number" min="0" matInput placeholder="{{'Temperature' | translate | async}}"  [(ngModel)]="pinTemL">
              <span matSuffix>°C</span>
            </mat-form-field>

            <div style="display: flex;flex-direction: column">
                <button *ngIf="(pinNOL!= pinCount) && !EnableStartInspection" mat-raised-button (click)="SavePinTempL()" style="height: fit-content;    margin: 3px;">{{Translate('Next')}}</button>
                <button *ngIf="(pinNOL== pinCount) && EnableStartInspection" mat-raised-button (click)="SavePinTempLAndDone()" style="height: fit-content;    margin: 3px;">{{Translate('Next & Done')}}</button>
                <button *ngIf="pinNOL== pinCount && !EnableStartInspection" mat-raised-button (click)="SkipL()" style="height: fit-content;    margin: 3px;">{{Translate('Skip')}}</button>
                <button *ngIf="pinNOL== pinCount && !EnableStartInspection" mat-raised-button (click)="AddAndGotoRight()" style="height: fit-content;    margin: 3px;">{{Translate('Next & Right')}}</button>
                <button *ngIf="(pinNOL== pinCount) && EnableStartInspection" mat-raised-button (click)="SkipLAndDone()" style="height: fit-content;    margin: 3px;">{{Translate('Skip & Done')}}</button>
            </div>
           

          </div>

          <div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 2%;" *ngIf="selectedSide==2">
             
              <mat-form-field > 
                  <input type="number" min="0" matInput placeholder="{{'Number' | translate | async}}"  [(ngModel)]="pinNOR" [readonly]="true">
                </mat-form-field>
          <mat-form-field>
              <input type="number" min="0" matInput placeholder="{{'Temperature' | translate | async}}"  [(ngModel)]="pinTemR">
              <span matSuffix>°C</span>
            </mat-form-field>

            <!-- <button mat-raised-button (click)="SavePinTempR()" style="height: fit-content">{{Translate('Next')}}</button>
            <button *ngIf="ShowSkipR" mat-raised-button (click)="SkipR()" style="height: fit-content">{{Translate('Skip')}}</button> -->

            <div  style="display: flex;flex-direction: column">
                <button *ngIf="(pinNOR!= pinCount) && !EnableStartInspection" mat-raised-button (click)="SavePinTempR()" style="height: fit-content;     margin: 3px;">{{Translate('Next')}}</button>
                <button *ngIf="(pinNOR== pinCount) && EnableStartInspection" mat-raised-button (click)="SavePinTempRAndDone()" style="height: fit-content;    margin: 3px;">{{Translate('Next & Done')}}</button>
                <button *ngIf="pinNOR== pinCount && !EnableStartInspection" mat-raised-button (click)="SkipR()" style="height: fit-content;    margin: 3px;">{{Translate('Skip')}}</button>
                <button *ngIf="pinNOR== pinCount && !EnableStartInspection" mat-raised-button (click)="AddAndGotoLeft()" style="height: fit-content;    margin: 3px;">{{Translate('Next & Right')}}</button>
                <button *ngIf="(pinNOR== pinCount) && EnableStartInspection" mat-raised-button (click)="SkipRAndDone()" style="height: fit-content;    margin: 3px;">{{Translate('Skip & Done')}}</button>
            </div>
           
          </div>

          <div *ngIf="!Validate">
              {{Translate('Please Enter Temperature')}}
          </div>
          <div *ngIf="!isValid">
              {{Translate('Please enter valid SMU')}}
            </div>
      <div class="ttmodal__footer">
          <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
          <!-- <button mat-raised-button color="warn"   [disabled]="!EnableStartInspection" (click)="SaveTemperatureInspection()"><span class="material-icons button__icon">check</span><span
              class="button__text">{{Translate('Start Inspection')}}</span></button> -->
        </div>
    </div>

    <div *ngIf="!isInspector">
      {{Translate('Please check your user permissions, Only inspector or super user can create inspections')}}
      <button mat-raised-button (click)="onNoClick()">{{Translate('Cancel')}}</button>
    </div>





  </div>


  

</div>